import { fromJS } from 'immutable';

import { ClientId,ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import {GetTemplateSender, GlobalLoading} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiUrl2 + 'template-sender-list';
    if(page === undefined){
        page = 1;
    }

    if (body == undefined) {
        body = {
            'client-id':ClientId,
            'sender-id' : [""],
            'namespace':""
        }
    }

    var query = {
        "search":body,
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":"ASC",
    };

    if(search != null){
        search.map((v,k)=>{
            if(v !== ""){
                query[k] = v;
            }
        });
    }

    var paramBody = {
        "query": query
    };

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };
    const response = await doFetch(url,argument);
    var data = fromJS({});

    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result');
        var items = []
        var arrData = data.get('data');

        arrData.forEach(itemss => {
            var arrTemplate = itemss.get('templates');
            var templateDetail ="";
            if(arrTemplate){
                arrTemplate.forEach(singleTemplate =>{
                    templateDetail = templateDetail+""+singleTemplate.get("template-name")+"\n";
                    }
                )
            }
            //debugger;
            items.push({
                'client-id': itemss.get('client-id'),
                'client-name': itemss.get('client-name'),
                'division-id': itemss.get('division-id'),
                'division-name': itemss.get('division-name'),
                'sender-id': itemss.get('sender-id'),
                'sender': itemss.get('sender'),
                'namespace': itemss.get('namespace'),
                'templates':itemss.get('templates'),
                'templateDetail': templateDetail
            })
        });

        var data2 = {
            'row-count': data.get('row-count'),
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': data.get('order-by'),
            'page': data.get('page'),
            'order': data.get('order'),
            'data': items
        }

    }

    dispatch({ type: GlobalLoading, showLoading: false});
    dispatch({ type: GetTemplateSender, data: fromJS(data2) });
};